module.exports = __webpack_public_path__ + "static/media/starterguide6v2.138d4195.png";